import React, { useState } from "react";
import { FaPlus } from "react-icons/fa";
import ModalVideo from "react-modal-video";
import { Link } from "react-router-dom";
import { FaGooglePlay } from "react-icons/fa";
import { FaApple } from "react-icons/fa";

const BannerThree = () => {
  const [isOpen, setOpen] = useState(false);
  return (
    <>
      {/* ================== BannerThree Start ==================*/}
      <div
        className='banner-area bg-relative banner-area-2 bg-cover'
        style={{ backgroundImage: 'url("./assets/img/banner-3/5.png")' }}
      >
        <img className='bg-img-2' src='assets/img/banner-3/4.png' alt='img' />
        <div className='container'>
          <div className='row'>
            <div className='col-lg-6 align-self-center'>
              <div className='banner-inner pe-xl-5'>
                <h6
                  className='subtitle '
                  data-aos='fade-right'
                  data-aos-delay='100'
                  data-aos-duration='1500'
                >
                  WELCOME TO AASAANN
                </h6>
                <h2
                  className='title'
                  data-aos='fade-right'
                  data-aos-delay='200'
                  data-aos-duration='1500'
                >
                  Simplifying the Art of  <span>Vegetable Market</span> Management
                </h2>
                <p
                  className='content pe-xl-5'
                  data-aos='fade-right'
                  data-aos-delay='250'
                  data-aos-duration='1500'
                >
                  Aasaann revolutionizes the vegetable market, bringing unmatched efficiency in managing transactions, farmers, and payments. Simplify your business with control at your fingertips!
                </p>

                <div className="d-flex gap-4">

                  <Link
                    className='btn btn-border-base '
                    data-aos='fade-right'
                    data-aos-delay='300'
                    data-aos-duration='1500'
                    to='/about'
                  >
                    <FaApple /> Available on the App Store
                  </Link>
                  {/* <div
                    style={{ display: 'flex', columnGap: '4px' }}
                    className='d-inline-block align-self-center wow animated fadeInLeft whitespace-nowrap'
                    data-aos='fade-right'
                    data-aos-delay='300'
                    data-aos-duration='1500'
                  >
                    <FaGooglePlay className="text-dark" />
                    <h6 className='d-inline-block'>Available on the Google Play</h6>
                  </div> */}
                  <a href="#" className="d-flex gap-2 align-items-center text-nowrap">
                  <FaGooglePlay className="text-dark" /> Available on the Google Play
                  </a>
                </div>
                {/* <ModalVideo
                  channel='youtube'
                  autoplay
                  isOpen={isOpen}
                  videoId='XM6kTQPzzpQ'
                  onClose={() => setOpen(false)}
                /> */}
              </div>
            </div>
            <div className='col-lg-6 col-md-10'>
              <div
                className='banner-thumb-3'
                data-aos='fade-left'
                data-aos-delay='100'
                data-aos-duration='1500'
              >
                <div className='main-img-wrap'>
                  <img
                    className='banner-animate-img banner-animate-img-1 left_image_bounce'
                    src='assets/img/banner-3/2.svg'
                    alt='img'
                  />
                  <img
                    className='banner-animate-img banner-animate-img-2 left_image_bounce'
                    src='assets/img/banner-3/3.svg'
                    alt='img'
                  />
                  <img
                    className='main-img'
                    src='assets/img/banner-3/1.png'
                    alt='img'
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ================== BannerThree End ==================*/}
    </>
  );
};

export default BannerThree;
